export const currency = {
  label: process.env.NEXT_PUBLIC_CURRENCY_LABEL || "تومان",
  code: process.env.NEXT_PUBLIC_CURRENCY_CODE || "IRT",
};
export const number = (value: number) =>
  new Intl.NumberFormat("fa-IR").format(value);
export const money = (value: number) => `${number(value)} ${currency.label}`;
export const hasSupabase = Boolean(
  process.env.NEXT_PUBLIC_SUPABASE_URL &&
  process.env.NEXT_PUBLIC_SUPABASE_PUBLISHABLE_KEY,
);
